import { Input, Button } from "@heroui/react";
export default function DoublePatti({
  customDigits,
  setCustomDigits,
  handleCustomInput,
  results,
  stakeInput,
  setStakeInput,
  selectedDigits,
  setSelectedDigits,
  randomCount,
  setRandomCount,
  handleDigitToggle,
  minMaxMap,
  selectedType,
  MAX_SELECTION_VALUE,
  betType,
  betTime,
  DIGITS_MAP,
  digitOptions,
  handleSubmit,
  selectedStake,
  digitStakes,
  setDigitStakes,
  lastSelectedDigit,
  setLastSelectedDigit,
}) {
  const handleRandomFill = () => {
    // const options = [...digitOptions];
    const options = DIGITS_MAP[betType + "_" + betTime];
    const count = parseInt(randomCount);
    if (isNaN(count) || count <= 0 || count > options.length) {
      alert(`Enter a valid number between 1 and ${options.length}`);
      return;
    }

    const shuffled = [...options].sort(() => 0.5 - Math.random());
    const randomDigits = shuffled.slice(0, count);
    setSelectedDigits(randomDigits);
  };

  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };

  const groupedPatti = chunkArray(DIGITS_MAP[betType + "_" + betTime], 9);

  let getdigitOps = DIGITS_MAP[betType + "_" + betTime];

  return (
    <>
      <div className=" border-gray-300 bg-white p-0 sm:p-2 max-w-6xl mx-auto w-full">
        <div className="flex flex-col md:flex-row justify-center items-center pb-2 gap-2 md:gap-4">
          <div className="text-md text-center font-medium text-m_red">
            Select Panna Digits
          </div>
          {/* <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
            <div className="flex items-center gap-2 text-md text-default-500">
              Enter Your Custom Digits
            </div>
            <Input
            placeholder="Eg: 123,234,345"
            size="md"
            radius="none"
            className="w-full md:w-36 border"
            type="text"
            min="1"
            maxLength="50"
            value={customDigits}
            onChange={handleCustomInput}
          />
          </div> */}
          {/* <div className="flex flex-col md:flex-row gap-2 w-full md:w-auto">
            <div className="flex items-center gap-2 text-md text-default-500">
              Max Selection Value = {MAX_SELECTION_VALUE[betType]}
            </div>
            <Input
              placeholder="Fill Digit"
              size="md"
              radius="none"
              className="w-full md:w-36 border"
              type="number"
              min="1"
              max={getdigitOps.length}
              value={randomCount}
              onChange={(e) => setRandomCount(e.target.value)}
            />
            <Button
              className="bg-matka_black text-white font-semibold"
              size="md"
              radius="none"
              onClick={handleRandomFill}
            >
              Guru selection
            </Button>
          </div> */}
        </div>

        {/* <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 xl:grid-cols-10 gap-2">
          {getdigitOps.map((number) => (
            <Button
              key={number}
              onClick={() => handleDigitToggle(number)}
              className={`h-14 border border-m_border1 bg-m_bg2`}
              variant="flat"
              color="default"
              style={{
                border: selectedDigits.includes(number)
                  ? "2px solid #007bff"
                  : "1px solid #ccc",
                borderRadius: "8px",
                textAlign: "center",
                cursor: "pointer",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <div className="flex flex-col items-center">
                <span>{number}</span>
                <span
                  style={{
                    fontSize: "12px",
                    color: results[number] >= 0 ? "green" : "red",
                  }}
                >
                  {results[number] >= 0
                    ? `${results[number]}`
                    : results[number]}
                </span>
              </div>
            </Button>
          ))}
        </div> */}

        <div className="space-y-6">
          {/* Main Heading */}
          {/* <div>
            <h2 className="text-xl text-center border-t border-b text-gray-800 mb-4 py-3">
            Select Panna Digits
          </h2>
          </div> */}

          {groupedPatti.map((group, groupIndex) => (
            <div key={groupIndex} className="border-t border-gray-400">
              {/* Group Title in First Row */}
              <div className="text-md font-semibold text-m_red text-center pb-1 pt-1">
                Panna of ank {groupIndex}
              </div>

              {/* Digits Grid in Second Row */}

              <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-4 xl:grid-cols-4 gap-2">
                {group.map((number) => (
                  <div className="flex flex-col">
                    <div className="text-center text-xs pb-1 font-bold">
                      <span>{number}</span>
                    </div>
                    <div>
                      <Button
                        className="w-full bg-white border border-gray-300 rounded-md text-sm"
                        onClick={() => handleDigitToggle(number)}
                        style={{
                          border:
                           lastSelectedDigit === number
                              ? "2px solid #007bff"
                              : "1px solid #ccc",
                          textAlign: "center",
                          cursor: "pointer",
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <div className="flex justify-between items-center  gap-0 w-full">
                          <div className="flex-1 text-center ml-1 text-xsm">
                            {selectedDigits.includes(number)
                              ? stakeInput
                              : digitStakes[number] || null}
                          </div>
                          <div
                            className="text-right pt-4 text-xxs"
                            style={{
                              color: results[number] >= 0 ? "green" : "red",
                            }}
                          >
                            {results[number] || null}
                          </div>
                        </div>
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-4">
            <div className="flex items-center gap-1 mb-4 md:mb-0">
              <span className="font-medium">SELECTED DIGITS:</span>
              <div className="flex flex-wrap gap-1">
                <span key="0" className="px-2 py-1  text-sm">
                  {Object.keys(digitStakes).length > 0
                    ? Object.keys(digitStakes).join(", ")
                    : ""}
                </span>
              </div>
              <Button
                onClick={() => {
                  setDigitStakes({});
                  setLastSelectedDigit("");
                }}
                size="lg"
                variant="none"
                className="text-blue-600 underline hover:text-blue-800 bg-transparent border-none shadow-none"
              >
                Clear All
              </Button>
            </div>
          </div>
          <div className="flex flex-col items-center gap-4">
            {/* <div className="font-medium">
              Stake
              <span className="text-m_text1  px-1 font-medium">
                ({minMaxMap[selectedType]?.min_stake} -{" "}
                {minMaxMap[selectedType]?.max_stake})
              </span>
            </div> */}
            {/* <div className="flex gap-4 w-full max-w-xs">
              <Input
                placeholder="Fill Value"
                type="number"
                min={minMaxMap[selectedType]?.min_stake || 10}
                max={minMaxMap[selectedType]?.max_stake || 1000}
                radius="none"
                className="flex-1 border"
                value={stakeInput}
                onChange={(e) => setStakeInput(e.target.value)}
              />
              <Button
                color="primary"
                radius="none"
                className="flex-1 bg-matka_black"
                onClick={handleSubmit}
              >
                SUBMIT BET
              </Button>
              
            </div> */}
            <div>
              <Button
                color="primary"
                radius="none"
                className="flex-1 bg-m_peach"
                onClick={handleSubmit}
              >
                SUBMIT BET
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
